/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var parser = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,3],$V1=[1,4],$V2=[1,5],$V3=[1,6],$V4=[1,7],$V5=[1,4,5,10,12,13,14,15,18,25,35,37,39,41,42,48,50,51,52,53,54,55,56,57,60,61,63,64,65,66,67],$V6=[1,4,5,10,12,13,14,15,18,25,28,35,37,39,41,42,48,50,51,52,53,54,55,56,57,60,61,63,64,65,66,67],$V7=[55,56,57],$V8=[2,36],$V9=[1,37],$Va=[1,36],$Vb=[1,38],$Vc=[1,35],$Vd=[1,43],$Ve=[1,41],$Vf=[1,45],$Vg=[1,14],$Vh=[1,23],$Vi=[1,18],$Vj=[1,19],$Vk=[1,20],$Vl=[1,21],$Vm=[1,22],$Vn=[1,24],$Vo=[1,25],$Vp=[1,26],$Vq=[1,27],$Vr=[1,28],$Vs=[1,29],$Vt=[1,32],$Vu=[1,33],$Vv=[1,34],$Vw=[1,39],$Vx=[1,40],$Vy=[1,42],$Vz=[1,44],$VA=[1,63],$VB=[1,62],$VC=[4,5,8,10,12,13,14,15,18,44,47,49,55,56,57,63,64,65,66,67],$VD=[1,66],$VE=[1,67],$VF=[1,68],$VG=[1,69],$VH=[1,70],$VI=[1,71],$VJ=[1,72],$VK=[1,73],$VL=[1,74],$VM=[1,75],$VN=[1,76],$VO=[1,77],$VP=[4,5,6,7,8,9,10,11,12,13,14,15,18],$VQ=[1,91],$VR=[1,92],$VS=[1,93],$VT=[1,100],$VU=[1,94],$VV=[1,97],$VW=[1,95],$VX=[1,96],$VY=[1,98],$VZ=[1,99],$V_=[1,103],$V$=[10,55,56,57],$V01=[4,5,6,8,10,11,13,17,18,19,20,55,56,57];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"idStringToken":3,"ALPHA":4,"NUM":5,"NODE_STRING":6,"DOWN":7,"MINUS":8,"DEFAULT":9,"COMMA":10,"COLON":11,"AMP":12,"BRKT":13,"MULT":14,"UNICODE_TEXT":15,"styleComponent":16,"UNIT":17,"SPACE":18,"STYLE":19,"PCT":20,"idString":21,"style":22,"stylesOpt":23,"classDefStatement":24,"CLASSDEF":25,"start":26,"eol":27,"QUADRANT":28,"document":29,"line":30,"statement":31,"axisDetails":32,"quadrantDetails":33,"points":34,"title":35,"title_value":36,"acc_title":37,"acc_title_value":38,"acc_descr":39,"acc_descr_value":40,"acc_descr_multiline_value":41,"section":42,"text":43,"point_start":44,"point_x":45,"point_y":46,"class_name":47,"X-AXIS":48,"AXIS-TEXT-DELIMITER":49,"Y-AXIS":50,"QUADRANT_1":51,"QUADRANT_2":52,"QUADRANT_3":53,"QUADRANT_4":54,"NEWLINE":55,"SEMI":56,"EOF":57,"alphaNumToken":58,"textNoTagsToken":59,"STR":60,"MD_STR":61,"alphaNum":62,"PUNCTUATION":63,"PLUS":64,"EQUALS":65,"DOT":66,"UNDERSCORE":67,"$accept":0,"$end":1},
terminals_: {2:"error",4:"ALPHA",5:"NUM",6:"NODE_STRING",7:"DOWN",8:"MINUS",9:"DEFAULT",10:"COMMA",11:"COLON",12:"AMP",13:"BRKT",14:"MULT",15:"UNICODE_TEXT",17:"UNIT",18:"SPACE",19:"STYLE",20:"PCT",25:"CLASSDEF",28:"QUADRANT",35:"title",36:"title_value",37:"acc_title",38:"acc_title_value",39:"acc_descr",40:"acc_descr_value",41:"acc_descr_multiline_value",42:"section",44:"point_start",45:"point_x",46:"point_y",47:"class_name",48:"X-AXIS",49:"AXIS-TEXT-DELIMITER",50:"Y-AXIS",51:"QUADRANT_1",52:"QUADRANT_2",53:"QUADRANT_3",54:"QUADRANT_4",55:"NEWLINE",56:"SEMI",57:"EOF",60:"STR",61:"MD_STR",63:"PUNCTUATION",64:"PLUS",65:"EQUALS",66:"DOT",67:"UNDERSCORE"},
productions_: [0,[3,1],[3,1],[3,1],[3,1],[3,1],[3,1],[3,1],[3,1],[3,1],[3,1],[3,1],[3,1],[16,1],[16,1],[16,1],[16,1],[16,1],[16,1],[16,1],[16,1],[16,1],[16,1],[21,1],[21,2],[22,1],[22,2],[23,1],[23,3],[24,5],[26,2],[26,2],[26,2],[29,0],[29,2],[30,2],[31,0],[31,1],[31,2],[31,1],[31,1],[31,1],[31,2],[31,2],[31,2],[31,1],[31,1],[34,4],[34,5],[34,5],[34,6],[32,4],[32,3],[32,2],[32,4],[32,3],[32,2],[33,2],[33,2],[33,2],[33,2],[27,1],[27,1],[27,1],[43,1],[43,2],[43,1],[43,1],[62,1],[62,2],[58,1],[58,1],[58,1],[58,1],[58,1],[58,1],[58,1],[58,1],[58,1],[58,1],[58,1],[58,1],[59,1],[59,1],[59,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 23:
this.$=$$[$0]
break;
case 24:
this.$=$$[$0-1]+''+$$[$0]
break;
case 26:
this.$ = $$[$0-1] + $$[$0];
break;
case 27:
this.$ = [$$[$0].trim()]
break;
case 28:
$$[$0-2].push($$[$0].trim());this.$ = $$[$0-2];
break;
case 29:
this.$ = $$[$0-4];yy.addClass($$[$0-2],$$[$0]);
break;
case 37:
this.$=[];
break;
case 42:
 this.$=$$[$0].trim();yy.setDiagramTitle(this.$); 
break;
case 43:
 this.$=$$[$0].trim();yy.setAccTitle(this.$); 
break;
case 44: case 45:
 this.$=$$[$0].trim();yy.setAccDescription(this.$); 
break;
case 46:
yy.addSection($$[$0].substr(8));this.$=$$[$0].substr(8);
break;
case 47:
yy.addPoint($$[$0-3], "", $$[$0-1], $$[$0], []);
break;
case 48:
yy.addPoint($$[$0-4], $$[$0-3], $$[$0-1], $$[$0], []);
break;
case 49:
yy.addPoint($$[$0-4], "", $$[$0-2], $$[$0-1], $$[$0]);
break;
case 50:
yy.addPoint($$[$0-5], $$[$0-4], $$[$0-2], $$[$0-1], $$[$0]);
break;
case 51:
yy.setXAxisLeftText($$[$0-2]); yy.setXAxisRightText($$[$0]);
break;
case 52:
$$[$0-1].text += " ⟶ "; yy.setXAxisLeftText($$[$0-1]);
break;
case 53:
yy.setXAxisLeftText($$[$0]);
break;
case 54:
yy.setYAxisBottomText($$[$0-2]); yy.setYAxisTopText($$[$0]);
break;
case 55:
$$[$0-1].text += " ⟶ "; yy.setYAxisBottomText($$[$0-1]);
break;
case 56:
yy.setYAxisBottomText($$[$0]);
break;
case 57:
yy.setQuadrant1Text($$[$0])
break;
case 58:
yy.setQuadrant2Text($$[$0])
break;
case 59:
yy.setQuadrant3Text($$[$0])
break;
case 60:
yy.setQuadrant4Text($$[$0])
break;
case 64:
 this.$={text:$$[$0], type: 'text'};
break;
case 65:
 this.$={text:$$[$0-1].text+''+$$[$0], type: $$[$0-1].type};
break;
case 66:
 this.$={text: $$[$0], type: 'text'};
break;
case 67:
 this.$={text: $$[$0], type: 'markdown'};
break;
case 68:
this.$=$$[$0];
break;
case 69:
this.$=$$[$0-1]+''+$$[$0];
break;
}
},
table: [{18:$V0,26:1,27:2,28:$V1,55:$V2,56:$V3,57:$V4},{1:[3]},{18:$V0,26:8,27:2,28:$V1,55:$V2,56:$V3,57:$V4},{18:$V0,26:9,27:2,28:$V1,55:$V2,56:$V3,57:$V4},o($V5,[2,33],{29:10}),o($V6,[2,61]),o($V6,[2,62]),o($V6,[2,63]),{1:[2,30]},{1:[2,31]},o($V7,$V8,{30:11,31:12,24:13,32:15,33:16,34:17,43:30,58:31,1:[2,32],4:$V9,5:$Va,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,18:$Vg,25:$Vh,35:$Vi,37:$Vj,39:$Vk,41:$Vl,42:$Vm,48:$Vn,50:$Vo,51:$Vp,52:$Vq,53:$Vr,54:$Vs,60:$Vt,61:$Vu,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz}),o($V5,[2,34]),{27:46,55:$V2,56:$V3,57:$V4},o($V7,[2,37]),o($V7,$V8,{24:13,32:15,33:16,34:17,43:30,58:31,31:47,4:$V9,5:$Va,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,18:$Vg,25:$Vh,35:$Vi,37:$Vj,39:$Vk,41:$Vl,42:$Vm,48:$Vn,50:$Vo,51:$Vp,52:$Vq,53:$Vr,54:$Vs,60:$Vt,61:$Vu,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz}),o($V7,[2,39]),o($V7,[2,40]),o($V7,[2,41]),{36:[1,48]},{38:[1,49]},{40:[1,50]},o($V7,[2,45]),o($V7,[2,46]),{18:[1,51]},{4:$V9,5:$Va,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,43:52,58:31,60:$Vt,61:$Vu,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz},{4:$V9,5:$Va,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,43:53,58:31,60:$Vt,61:$Vu,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz},{4:$V9,5:$Va,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,43:54,58:31,60:$Vt,61:$Vu,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz},{4:$V9,5:$Va,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,43:55,58:31,60:$Vt,61:$Vu,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz},{4:$V9,5:$Va,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,43:56,58:31,60:$Vt,61:$Vu,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz},{4:$V9,5:$Va,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,43:57,58:31,60:$Vt,61:$Vu,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz},{4:$V9,5:$Va,8:$VA,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,18:$VB,44:[1,58],47:[1,59],58:61,59:60,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz},o($VC,[2,64]),o($VC,[2,66]),o($VC,[2,67]),o($VC,[2,70]),o($VC,[2,71]),o($VC,[2,72]),o($VC,[2,73]),o($VC,[2,74]),o($VC,[2,75]),o($VC,[2,76]),o($VC,[2,77]),o($VC,[2,78]),o($VC,[2,79]),o($VC,[2,80]),o($VC,[2,81]),o($V5,[2,35]),o($V7,[2,38]),o($V7,[2,42]),o($V7,[2,43]),o($V7,[2,44]),{3:65,4:$VD,5:$VE,6:$VF,7:$VG,8:$VH,9:$VI,10:$VJ,11:$VK,12:$VL,13:$VM,14:$VN,15:$VO,21:64},o($V7,[2,53],{59:60,58:61,4:$V9,5:$Va,8:$VA,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,18:$VB,49:[1,78],63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz}),o($V7,[2,56],{59:60,58:61,4:$V9,5:$Va,8:$VA,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,18:$VB,49:[1,79],63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz}),o($V7,[2,57],{59:60,58:61,4:$V9,5:$Va,8:$VA,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,18:$VB,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz}),o($V7,[2,58],{59:60,58:61,4:$V9,5:$Va,8:$VA,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,18:$VB,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz}),o($V7,[2,59],{59:60,58:61,4:$V9,5:$Va,8:$VA,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,18:$VB,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz}),o($V7,[2,60],{59:60,58:61,4:$V9,5:$Va,8:$VA,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,18:$VB,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz}),{45:[1,80]},{44:[1,81]},o($VC,[2,65]),o($VC,[2,82]),o($VC,[2,83]),o($VC,[2,84]),{3:83,4:$VD,5:$VE,6:$VF,7:$VG,8:$VH,9:$VI,10:$VJ,11:$VK,12:$VL,13:$VM,14:$VN,15:$VO,18:[1,82]},o($VP,[2,23]),o($VP,[2,1]),o($VP,[2,2]),o($VP,[2,3]),o($VP,[2,4]),o($VP,[2,5]),o($VP,[2,6]),o($VP,[2,7]),o($VP,[2,8]),o($VP,[2,9]),o($VP,[2,10]),o($VP,[2,11]),o($VP,[2,12]),o($V7,[2,52],{58:31,43:84,4:$V9,5:$Va,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,60:$Vt,61:$Vu,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz}),o($V7,[2,55],{58:31,43:85,4:$V9,5:$Va,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,60:$Vt,61:$Vu,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz}),{46:[1,86]},{45:[1,87]},{4:$VQ,5:$VR,6:$VS,8:$VT,11:$VU,13:$VV,16:90,17:$VW,18:$VX,19:$VY,20:$VZ,22:89,23:88},o($VP,[2,24]),o($V7,[2,51],{59:60,58:61,4:$V9,5:$Va,8:$VA,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,18:$VB,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz}),o($V7,[2,54],{59:60,58:61,4:$V9,5:$Va,8:$VA,10:$Vb,12:$Vc,13:$Vd,14:$Ve,15:$Vf,18:$VB,63:$Vv,64:$Vw,65:$Vx,66:$Vy,67:$Vz}),o($V7,[2,47],{22:89,16:90,23:101,4:$VQ,5:$VR,6:$VS,8:$VT,11:$VU,13:$VV,17:$VW,18:$VX,19:$VY,20:$VZ}),{46:[1,102]},o($V7,[2,29],{10:$V_}),o($V$,[2,27],{16:104,4:$VQ,5:$VR,6:$VS,8:$VT,11:$VU,13:$VV,17:$VW,18:$VX,19:$VY,20:$VZ}),o($V01,[2,25]),o($V01,[2,13]),o($V01,[2,14]),o($V01,[2,15]),o($V01,[2,16]),o($V01,[2,17]),o($V01,[2,18]),o($V01,[2,19]),o($V01,[2,20]),o($V01,[2,21]),o($V01,[2,22]),o($V7,[2,49],{10:$V_}),o($V7,[2,48],{22:89,16:90,23:105,4:$VQ,5:$VR,6:$VS,8:$VT,11:$VU,13:$VV,17:$VW,18:$VX,19:$VY,20:$VZ}),{4:$VQ,5:$VR,6:$VS,8:$VT,11:$VU,13:$VV,16:90,17:$VW,18:$VX,19:$VY,20:$VZ,22:106},o($V01,[2,26]),o($V7,[2,50],{10:$V_}),o($V$,[2,28],{16:104,4:$VQ,5:$VR,6:$VS,8:$VT,11:$VU,13:$VV,17:$VW,18:$VX,19:$VY,20:$VZ})],
defaultActions: {8:[2,30],9:[2,31]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
            function lex() {
            var token;
            token = tstack.pop() || lexer.lex() || EOF;
            if (typeof token !== 'number') {
                if (token instanceof Array) {
                    tstack = token;
                    token = tstack.pop();
                }
                token = self.symbols_[token] || token;
            }
            return token;
        }
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
        if (typeof action === 'undefined' || !action.length || !action[0]) {
            var errStr = '';
            expected = [];
            for (p in table[state]) {
                if (this.terminals_[p] && p > TERROR) {
                    expected.push('\'' + this.terminals_[p] + '\'');
                }
            }
            if (lexer.showPosition) {
                errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
            } else {
                errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
            }
            this.parseError(errStr, {
                text: lexer.match,
                token: this.terminals_[symbol] || symbol,
                line: lexer.yylineno,
                loc: yyloc,
                expected: expected
            });
        }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};

/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"case-insensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:/* skip comments */
break;
case 1:/* skip comments */
break;
case 2:return 55;
break;
case 3:/* do nothing */
break;
case 4: this.begin("title");return 35; 
break;
case 5: this.popState(); return "title_value"; 
break;
case 6: this.begin("acc_title");return 37; 
break;
case 7: this.popState(); return "acc_title_value"; 
break;
case 8: this.begin("acc_descr");return 39; 
break;
case 9: this.popState(); return "acc_descr_value"; 
break;
case 10: this.begin("acc_descr_multiline");
break;
case 11: this.popState(); 
break;
case 12:return "acc_descr_multiline_value";
break;
case 13:return 48;
break;
case 14:return 50;
break;
case 15:return 49
break;
case 16:return 51;
break;
case 17:return 52;
break;
case 18:return 53;
break;
case 19:return 54;
break;
case 20:return 25;
break;
case 21: this.begin("md_string");
break;
case 22: return "MD_STR";
break;
case 23: this.popState();
break;
case 24:this.begin("string");
break;
case 25:this.popState();
break;
case 26:return "STR";
break;
case 27:this.begin('class_name')
break;
case 28:this.popState(); return 47;
break;
case 29:this.begin("point_start"); return 44;
break;
case 30:this.begin('point_x'); return 45;
break;
case 31:this.popState();
break;
case 32:this.popState(); this.begin('point_y');
break;
case 33:this.popState(); return 46;
break;
case 34:return 28;
break;
case 35:return 4;
break;
case 36:return 15;
break;
case 37:return 11;
break;
case 38:return 64;
break;
case 39:return 10;
break;
case 40:return 65;
break;
case 41:return 65;
break;
case 42:return 14;
break;
case 43:return 13;
break;
case 44:return 67;
break;
case 45:return 66;
break;
case 46:return 12;
break;
case 47:return 8;
break;
case 48:return 5;
break;
case 49:return 18;
break;
case 50:return 56;
break;
case 51:return 63;
break;
case 52:return 57;
break;
}
},
rules: [/^(?:%%(?!\{)[^\n]*)/i,/^(?:[^\}]%%[^\n]*)/i,/^(?:[\n\r]+)/i,/^(?:%%[^\n]*)/i,/^(?:title\b)/i,/^(?:(?!\n||)*[^\n]*)/i,/^(?:accTitle\s*:\s*)/i,/^(?:(?!\n||)*[^\n]*)/i,/^(?:accDescr\s*:\s*)/i,/^(?:(?!\n||)*[^\n]*)/i,/^(?:accDescr\s*\{\s*)/i,/^(?:[\}])/i,/^(?:[^\}]*)/i,/^(?: *x-axis *)/i,/^(?: *y-axis *)/i,/^(?: *--+> *)/i,/^(?: *quadrant-1 *)/i,/^(?: *quadrant-2 *)/i,/^(?: *quadrant-3 *)/i,/^(?: *quadrant-4 *)/i,/^(?:classDef\b)/i,/^(?:["][`])/i,/^(?:[^`"]+)/i,/^(?:[`]["])/i,/^(?:["])/i,/^(?:["])/i,/^(?:[^"]*)/i,/^(?::::)/i,/^(?:^\w+)/i,/^(?:\s*:\s*\[\s*)/i,/^(?:(1)|(0(.\d+)?))/i,/^(?:\s*\] *)/i,/^(?:\s*,\s*)/i,/^(?:(1)|(0(.\d+)?))/i,/^(?: *quadrantChart *)/i,/^(?:[A-Za-z]+)/i,/^(?:[^\x00-\x7F]+)/i,/^(?::)/i,/^(?:\+)/i,/^(?:,)/i,/^(?:=)/i,/^(?:=)/i,/^(?:\*)/i,/^(?:#)/i,/^(?:[\_])/i,/^(?:\.)/i,/^(?:&)/i,/^(?:-)/i,/^(?:[0-9]+)/i,/^(?:\s)/i,/^(?:;)/i,/^(?:[!"#$%&'*+,-.`?\\_/])/i,/^(?:$)/i],
conditions: {"class_name":{"rules":[28],"inclusive":false},"point_y":{"rules":[33],"inclusive":false},"point_x":{"rules":[32],"inclusive":false},"point_start":{"rules":[30,31],"inclusive":false},"acc_descr_multiline":{"rules":[11,12],"inclusive":false},"acc_descr":{"rules":[9],"inclusive":false},"acc_title":{"rules":[7],"inclusive":false},"title":{"rules":[5],"inclusive":false},"md_string":{"rules":[22,23],"inclusive":false},"string":{"rules":[25,26],"inclusive":false},"INITIAL":{"rules":[0,1,2,3,4,6,8,10,13,14,15,16,17,18,19,20,21,24,27,29,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})(); 
	parser.parser = parser;
	export { parser };
	export default parser;
	